import { __assign } from 'tslib';
import * as React from 'react';
import { ProductCardSectionOrientationContext } from '../ProductCardSection.esm.js';
import ProductCardSectionItemHorizontal from './ProductCardSectionItemHorizontal/ProductCardSectionItemHorizontal.esm.js';
import ProductCardSectionItemVertical from './ProductCardSectionItemVertical/ProductCardSectionItemVertical.esm.js';

var ProductCardSectionItem = function (_a) {
    var fields = _a.fields, id = _a.id;
    var orientationOnDesktop = React.useContext(ProductCardSectionOrientationContext);
    var isHorizontalOnDesktop = orientationOnDesktop === 'horizontal';
    return (React.createElement(React.Fragment, null,
        React.createElement(ProductCardSectionItemHorizontal, __assign({}, fields, { id: "".concat(id, "-horizontal"), isHorizontalOnDesktop: isHorizontalOnDesktop })),
        React.createElement(ProductCardSectionItemVertical, __assign({}, fields, { id: "".concat(id, "-vertical"), isHorizontalOnDesktop: isHorizontalOnDesktop }))));
};

export { ProductCardSectionItem as default };
//# sourceMappingURL=ProductCardSectionItem.esm.js.map
